import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";
import { SortOrder } from "../../../../Global/Types/GlobalTypes";
import { GameStatusEnum } from "../../../TopX/Enums/GameStatusEnum";

export default class BracketGameFilters extends MainFiltersBQ {
  status?: GameStatusEnum | null = null;
  sortOrder?: SortOrder | null = null;
  gameIds?: string[] | null = null;

  constructor(filters: any) {
    super(filters);
    this.status = filters?.status || null;
    this.sortOrder = filters?.sortOrder || null;
    this.gameIds = filters?.gameIds || null;
  }

  constructMainFiltersUrl?(): string {
    let url = super.constructMainFiltersUrl();

    if (this.status && Object.values(GameStatusEnum).includes(this.status)) {
      url += "&";
      url += `status=${this.status}`;
    } else if (this.status !== null) {
      console.warn(
        `The filter 'status' has the following INVALID value: ${this.status}. It will be not passed as a query param in the URL. For more information visit our documentation.`
      );
    }

    if (
      this.sortOrder &&
      (this.sortOrder === "asc" ||
        this.sortOrder === "desc" ||
        this.sortOrder === "ASC" ||
        this.sortOrder === "DESC")
    ) {
      url += "&";
      url += `sort_order=${this.sortOrder}`;
    } else if (this.sortOrder !== null) {
      console.warn(
        `The filter 'sortOrder' has the following INVALID value: ${this.sortOrder}. It will be not passed as a query param in the URL. For more information visit our documentation.`
      );
    }

    if (
      this.gameIds &&
      Array.isArray(this.gameIds) &&
      this.gameIds.length > 0
    ) {
      url += "&";
      url += `game_ids=${this.gameIds}`;
    } else if (this.gameIds !== null) {
      console.warn(
        `The filter 'gameIds' has the following INVALID value: ${this.gameIds}. It will be not passed as a query param in the URL. For more information visit our documentation.`
      );
    }

    return url;
  }
}
